import { Middleware } from "../middleware"

export default {

    getSolicitacoes(filter) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.rangeDate?.start,
                endDate: filter.rangeDate?.end,
                idCompany: filter.idCompany,
                status: filter.status,
                idAnalyst: filter.idAnalyst,
                criticality: filter.criticality
            })
            .build()

    },
    getDetailsRequests(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/${id}`)
            .build()

    },
    getListSiemVendor() {
        return new Middleware()
            .method('GET')
            .append(`/odin/siem/vendors`)
            .build()
            .then( ({ data }) => {
                return Object.entries(data).map( ([ value, text ]) => {
                    return { value, text }
                })
            })

    },

    getMessageRequests(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/${id}/messages`)
            .build()

    },
    sendMessagesRequests(message, id) {
        return new Middleware()
            .method('POST')
            .setData(message)
            .append(`/odin/requests/${id}/messages`)
            .build()

    },


    getStatusRequests() {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/status_list`)
            .build()

    },

  
    getMessagesRequests(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/${id}/messages}`)
            .build()

    },



    getCompanies() {
        return new Middleware()
            .method('GET')
            .append(`/companies/`)
            .build()
            .then(({ data }) => {
                return data.filter(company => {
                return company.isActive
                }).map(company => {
                return {
                    text: company.name,
                    value: company.idCompany
                }
                })
            })

    },
    getCriticalities() {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/get_criticality/`)
            .build()
    },
    getTypes() {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/get_types/`)
            .build()
    },

    createRequest(data) {
        return new Middleware()
            .method("POST")
            .append('/odin/requests/new-request')
            .setData(data)
            .build()
    },
    getHistoryRequest(id) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/${id}/get_history`)
            .build()
    },
    postHistoryRequest(id, data) {
        return new Middleware()
            .method('POST')
            .setData(data)
            .append(`/odin/requests/${id}/new_history`)
            .build()
    },

    updateRequest(data,id){
        return new Middleware()
        .method('PUT')
        .setData(data)
        .append(`/odin/requests/update/${id}`)
        .build()
    }



}